export default __webpack_public_path__ + "static/media/wrong-answer.410bfa26.mp3";